import { ToggleGroup } from '@/components/ui/toggle-group';
import { Select } from '@/components/ui/select';
import { useLanguage } from '@/i18n/language-context';
import { isLocale } from '@/i18n/translations';
import { useAnalytics } from '@/lib/use-analytics';
import { languagePersistenceCopy } from '@/i18n/language-persistence-copy';

const languages = [
  { locale: 'ro', name: 'Română', flag: 'ro' },
  { locale: 'en', name: 'English', flag: 'gb' },
  { locale: 'hu', name: 'Magyar', flag: 'hu' },
] as const;

export const LanguageSwitcher = (): JSX.Element => {
  const { t, locale, setLocale, persistence } = useLanguage();
  const track = useAnalytics();
  const selected = languages.find((language) => language.locale === locale) ?? languages[0];
  const options = languages.map((language) => {
    const flag = (
      <img
        className="language-switcher__flag"
        src={`/flags/${language.flag}.svg`}
        alt=""
        width="23"
        height="16"
      />
    );
    return { value: language.locale, label: language.name, content: flag, icon: flag };
  });
  const changeLanguage = (next: string): void => {
    if (!isLocale(next) || locale === next) return;
    track('Public Language Changed', {
      previous_language: locale,
      language: next,
    });
    setLocale(next);
  };
  return (
    <>
      <Select
        className="language-switcher header-preference-trigger header-preference--compact"
        popupClassName="header-preference-popup"
        aria-label={`${t.language}: ${selected.name}`}
        value={locale}
        options={options}
        onValueChange={changeLanguage}
        triggerContent={<img src={`/flags/${selected.flag}.svg`} alt="" width="23" height="16" />}
      />
      <ToggleGroup
        className="language-switcher header-preference--expanded"
        label={t.language}
        value={locale}
        options={options}
        onValueChange={changeLanguage}
      />
      {persistence?.state === 'saving' && (
        <span className="visually-hidden" role="status">
          {languagePersistenceCopy[locale].saving}
        </span>
      )}
    </>
  );
};
